import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { SharedModule } from '../shared.module';

@Component({
  standalone: true,
  selector: 'icu-loading-button',
  templateUrl: 'loading-button.component.html',
  imports: [SharedModule, MatProgressBarModule]
})
export class LoadingButtonComponent {
  @Input() text?: string;
  @Input() loading?: boolean;
  @Input() disabled?: boolean;
  @Input() isRaised?: boolean;

  @Output() clicked = new EventEmitter<void>();

  onClicked(ev: Event): void {
    ev.stopPropagation();
    if (this.loading) {
      return;
    }
    this.clicked.emit();
  }
}
